<template>
  <div>
    <v-layout fill-height pa-3 row wrap>
      <v-pagination
        v-model="currentQuestion"
        :length="totalQuestions"
        :total-visible="5"
        style="width: auto"
      />
    </v-layout>

    <v-container fluid grid-list-xl>
      <question
        :disabled="questions[currentQuestion - 1].finished"
        :loading="this.loading"
        :mode="2"
        :question="questions[currentQuestion - 1]"
      />
    </v-container>
  </div>
</template>

<script>
import Question from "./Question";
export default {
  components: { Question },
  data() {
    return {
      questions: [],
      currentQuestion: 1,
      totalQuestions: 1,
      loading: true,
    };
  },
  props: {
    review: null,
  },
  created() {
    this.loading = true;

    this.questions = this.review.questions.data;
    this.totalQuestions = this.questions.length;
    this.mapQuestions(this.questions);
    this.currentQuestion = 1;
    this.loading = false;
  },
  methods: {
    mapQuestions(questionsArray) {
      this.questions = this.questions.map((item) => {
        const q = questionsArray.findIndex((q) => {
          return q.id === item.id;
        });
        // console.log('index encontrado: ', q)
        if (q > -1) {
          item.correct_answer = questionsArray[q].correct_answer;
          item.correct = questionsArray[q].correct;
          item.finished = item.correct !== undefined && item.correct !== null;
        } else {
          item.correct_answer = null;
          item.correct = null;
          item.finished = false;
        }
        return item;
      });
    },
  },
};
</script>

<style></style>
